<script>
import { mapState } from 'vuex';
import TwWysiwyg from '../TwWysiwyg';

export default {
  name: 'ItineraryEditPosterIncluded',
  components: { TwWysiwyg },
  props: {
    itineraryPoster: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      itineraryId: null,
      domainId: null,
    };
  },
  computed: {
    ...mapState({
      loading: state => state.itinerary.poster.loading,
      error: state => state.itinerary.poster.error,
    }),
  },
  methods: {
    save() {
      this.$emit('save', this.itineraryPoster);
    },
    reorderPosterInclude(posterIncludeId, direction) {
      const index = this.itineraryPoster.includes.findIndex(posterInclude => posterInclude.id === posterIncludeId);
      if (index === -1) return;

      if (direction === 'up' && index > 0) {
        /* eslint-disable max-len */
        [ this.itineraryPoster.includes[index - 1], this.itineraryPoster.includes[index] ] = [ this.itineraryPoster.includes[index], this.itineraryPoster.includes[index - 1] ];
        this.itineraryPoster.includes[index - 1].order -= 1;
        this.itineraryPoster.includes[index].order += 1;
      } else if (direction === 'down' && index < this.itineraryPoster.includes.length - 1) {
        [ this.itineraryPoster.includes[index + 1], this.itineraryPoster.includes[index] ] = [ this.itineraryPoster.includes[index], this.itineraryPoster.includes[index + 1] ];
        this.itineraryPoster.includes[index + 1].order += 1;
        this.itineraryPoster.includes[index].order -= 1;
      }
      this.save();
    },
    duplicatePosterInclude(posterIncludeId) {
      const index = this.itineraryPoster.includes.findIndex(posterInclude => posterInclude.id === posterIncludeId);
      if (index !== -1) {
        const newPosterInclude = { ...this.itineraryPoster.includes[index], id: null };
        this.itineraryPoster.includes.push(newPosterInclude);
        this.save();
      }
    },
    deletePosterInclude(posterIncludeId) {
      const index = this.itineraryPoster.includes.findIndex(posterInclude => posterInclude.id === posterIncludeId);
      if (index !== -1) {
        this.itineraryPoster.includes.splice(index, 1);
        this.save();
      }
    },
  },
};
</script>

<template>
  <div>
    <template v-if="!itineraryPoster">
      <p>Loading..</p>
    </template>
    <template v-else>
      <v-card>
        <v-card-title class="pb-0">
          <div class="headline">Included</div>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="itineraryPoster.includes"
            :loading="loading"
            hide-actions
            hide-headers
          >
            <template v-slot:items="props">
              <tr>
                <td>Order: {{ props.index }}</td>
                <td>
                  <v-text-field
                    v-model="props.item.headline"
                    label="Headline"
                    hide-details
                    class="my-4"
                  />
                </td>
                <td class="text-xs-right">
                  <v-btn
                    fab
                    small
                    depressed
                    color="primary"
                    @click="duplicatePosterInclude(props.item.id)"
                  >
                    <v-icon>copy_all</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="props.index === 0"
                    fab
                    small
                    depressed
                    color="secondary"
                    @click="reorderPosterInclude(props.item.id, 'up')"
                  >
                    <v-icon>arrow_upward</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="props.index === itineraryPoster.includes.length - 1"
                    fab
                    small
                    depressed
                    color="secondary"
                    @click="reorderPosterInclude(props.item.id, 'down')"
                  >
                    <v-icon>arrow_downward</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    small
                    depressed
                    color="error"
                    @click="deletePosterInclude(props.item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryEditPosterIncluded.vue